import { render, staticRenderFns } from "./SingleSelectQuestion.vue?vue&type=template&id=0b3468e2"
import script from "./SingleSelectQuestion.vue?vue&type=script&lang=js"
export * from "./SingleSelectQuestion.vue?vue&type=script&lang=js"
import style0 from "./SingleSelectQuestion.vue?vue&type=style&index=0&id=0b3468e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports